export default __webpack_public_path__ + "static/media/sap-logo-svg.447c7ca3.svg";